<!-- Floating Doocti CTI Panel -->
<div class="doocti-panel" [class.doocti-panel--collapsed]="!isVisible">
  <!-- Toggle Button -->
  <button
    class="doocti-toggle-btn"
    (click)="togglePanel()"
    [attr.aria-label]="isVisible ? 'Minimize phone panel' : 'Open phone panel'"
    [attr.title]="isVisible ? 'Minimize' : 'Open Phone'"
  >
    <!-- Phone icon (SVG) -->
    @if (!isVisible) {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        />
      </svg>
    } @else {
      <!-- Minimize icon (SVG) -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    }
  </button>

  <!-- Iframe Container -->
  <div class="doocti-iframe-wrapper" [class.doocti-iframe-wrapper--hidden]="!isVisible">
    <div class="doocti-panel-header">
      <div class="doocti-panel-actions">
        <button
          type="button"
          class="doocti-reconnect-btn"
          (click)="reconnect()"
          [disabled]="isReconnecting"
          [attr.title]="isReconnecting ? 'Reconnecting...' : 'Force Logout & Reconnect'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.doocti-spin]="isReconnecting"
          >
            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
          </svg>
          <span>{{ isReconnecting ? 'Connecting...' : 'Reconnect' }}</span>
        </button>
      </div>
    </div>
    <div #iframeContainer class="doocti-iframe-host"></div>
  </div>
</div>
